import ConfigurationHelper from "../configuration/ClientConfigurationHelper";

export class Analytics {
    productImpresion(product, assetId) {
        this.sendAnalytics("pi", {
            vd: assetId,
            ct: product.id,
            li: ConfigurationHelper.getGlobalConfiguration().loginId,
            ...(ConfigurationHelper.getGlobalConfiguration().channelId ? { pg: ConfigurationHelper.getGlobalConfiguration().channelId } : {})
            
        });
    }

    productClick(product, assetId) {
        this.sendAnalytics("pk", {
            vd: assetId,
            ct: product.id,
            li: ConfigurationHelper.getGlobalConfiguration().loginId,
            ...(ConfigurationHelper.getGlobalConfiguration().channelId ? { pg: ConfigurationHelper.getGlobalConfiguration().channelId } : {})
        });

    }
    photoView(asset) {
        if (!asset) return;

        let data = {
            vd: asset.id,
            li: TVSite.loginId
        };
        this.sendAnalytics("pv", data);
    }

    pmEvent(asset) {
        if(!asset) return;
        this.sendAnalytics("pm", {
            li: TVSite.loginId,
            vd: asset.id,
            ui: asset.user_id,
            vti: 0
        });
    }

    sendAnalytics(type, data) {
        if ("_tvpa" in window) {
            _tvpa.push(["track", type, data]);
        }
    }
}

export default new Analytics();
